import { Controller } from "@hotwired/stimulus"

/**
 * EmptyController - Maneja la visibilidad de elementos basado en si una lista está vacía
 * Conecta a data-controller="empty"
 */
export default class extends Controller {
  static targets = ["list", "table", "empty"]

  #observer = null

  connect() {
    this.#setupObserver()
    this.#updateVisibility()
  }

  disconnect() {
    this.#observer?.disconnect()
  }

  #setupObserver() {
    this.#observer = new MutationObserver(() => this.#updateVisibility())
    
    this.#observer.observe(this.element, {
      childList: true,
      subtree: true,
      attributes: false
    })
  }

  #updateVisibility() {
    const hasItems = this.listTarget.children.length > 0
    
    this.tableTarget.classList.toggle("d-none", !hasItems)
    this.emptyTarget.classList.toggle("d-none", hasItems)
  }
}
